export default "__VITE_ASSET__CEMOB2ZL__"